module.exports = __webpack_public_path__ + "img/net_des_3.e9819c71.jpg";